import "./index.css";
import { ColorModeProvider, createLocalStorageManager } from "@kobalte/core";
import { Route, Router } from "@solidjs/router";
import { render } from "solid-js/web";
import { App } from "./App";
import { ApprovalsPage } from "./pages/Approvals";
import { DevicePage } from "./pages/Device";
import { DevicesPage } from "./pages/Devices";
import { NotFoundPage } from "./pages/NotFound";
import { SettingsPage } from "./pages/Settings";

const storage = createLocalStorageManager("fistos-theme");

render(
  () => (
    <ColorModeProvider storageManager={storage}>
      <Router root={App}>
        <Route path="/" component={DevicesPage} />
        <Route path="/devices/:id" component={DevicePage} />
        <Route path="/approvals" component={ApprovalsPage} />
        <Route path="/settings" component={SettingsPage} />
        <Route path="*" component={NotFoundPage} />
      </Router>
    </ColorModeProvider>
  ),
  document.getElementById("root")!,
);
